import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
const languageStorageKey = 'language';
const supportedLanguages = ['cs', 'en'];
export const LanguageContext = React.createContext({
    language: getLanguage(),
    setLanguage: () => { },
});
LanguageProvider.displayName = 'LanguageProvider';
export function LanguageProvider(props) {
    const [language, setLanguage] = React.useState(getLanguage());
    return (_jsx(LanguageContext.Provider, { value: { language, setLanguage }, children: props.children }));
}
export function useLanguage() {
    const state = React.useContext(LanguageContext);
    return state.language;
}
export function getLanguage() {
    const selectedLanguage = localStorage.getItem(languageStorageKey);
    if (selectedLanguage && supportedLanguages.includes(selectedLanguage)) {
        return selectedLanguage;
    }
    const userLang = navigator.language || navigator.userLanguage;
    if (userLang.toLowerCase().startsWith('cs')) {
        return 'cs';
    }
    return 'en';
}
export function setLanguage(language) {
    localStorage.setItem(languageStorageKey, language);
}
